import { Index, LoginPage, FormListPage, FormMainPage, DraftPage, FormDetailPage, FormPrintPage, FormCommonPage, FormDataListPage, PcLoginPage } from '../components/MyPages';

export default [
    { path: "/", name: "App", component: Index, auth: true },
    { path: "/login", name: "login", component: LoginPage },
    { path: "/pclogin", name: "pclogin", component: PcLoginPage },
    { path: "/formlist", name: "formlist", component: FormListPage, auth: false },
    { path: "/formmain", name: "formmain", component: FormMainPage, auth: false },
    { path: "/draft", name: "draft", component: DraftPage, auth: true },
    { path: "/formdetail", name: "formdetail", component: FormDetailPage, auth: false },
    { path: "/formprint", name: "formprint", component: FormPrintPage },
    { path: "/formcommon", name: "formcommon", component: FormCommonPage, auth: true },
    { path: "/formdatalist", name: "formdatalist", component: FormDataListPage, auth: true },
]